import React from 'react';
import Loadable from 'react-loadable';
import Loader from 'desktop/components/Common/BlankLoader.js';

const ReviewsLoadable = Loadable({
    loader: () => import('./Reviews.js' /* webpackChunkName: 'reviews' */).then(module => module.default),
    loading: () => <Loader />
});

export default ReviewsLoadable;
